import React, { useEffect, useState } from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { Helmet } from 'react-helmet';
import client from '../components/contentfulFiles';
import backgroundImage from '../assets/bulletin_hero.jpg';
import withScroll from '../components/scroll';
import '../styles/bulletin.css';

const fetchFieldNames = async (setFieldNames, setError) => {
  try {
    const response = await client.getContentTypes();
    const fields = {};
    response.items.forEach((contentType) => {
      contentType.fields.forEach((field) => {
        fields[field.id] = field.name;
      });
    });
    setFieldNames(fields);
  } catch (error) {
    console.error('Error fetching content types:', error);
    setError('Failed to fetch content types.');
  }
};

function Bulletin({ sectionRef }) {
  const [sabbathSchoolEvents, setSabbathSchoolEvents] = useState([]);
  const [divineServiceEvents, setDivineServiceEvents] = useState([]);
  const [fieldNames, setFieldNames] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFieldNames(setFieldNames, setError);

    const fetchEvents = async (contentType, setEvents) => {
      try {
        const response = await client.getEntries({ content_type: contentType });
        setEvents(response.items.map((item) => item.fields));
      } catch (err) {
        console.error(`Error fetching ${contentType}:`, err);
        setError(`Failed to fetch ${contentType} events.`);
      }
    };

    fetchEvents('sabbathSchool', setSabbathSchoolEvents);
    fetchEvents('divineService', setDivineServiceEvents);
  }, []);

  const renderBulletinRows = (events) => {
    if (events.length === 0) {
      return <p className="bulletin-empty">No information available yet.</p>;
    }
    return events.map((event, index) => (
      <div key={index} className="bulletin-event">
        {Object.entries(event).map(([fieldId, value]) => (
          <div key={fieldId} className="b-row">
            <span className="b-label">
              {fieldNames[fieldId] || fieldId}
            </span>
            <span className="b-value">{value}</span>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <div className="bulletin-page">
      <Helmet>
        <title>Bulletin — Calvary First Nigerian SDA Church</title>
      </Helmet>
      <Navbar />
      <main>

        {/* ── Hero ── */}
        <section
          className="bulletin-hero"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="bulletin-hero-content">
            <h1>This Week's Bulletin</h1>
          </div>
        </section>

        {/* ── Bulletin content ── */}
        <section ref={sectionRef} className="bulletin-wrap">
          <div className="bulletin-page-head">
            <h2>Weekly Bulletin</h2>
            <p>Calvary First Nigerian Seventh-day Adventist Church &middot; 778 Lexington Ave, Brooklyn NY</p>
          </div>

          {error && <p className="bulletin-error">{error}</p>}

          <div className="bulletin-grid">

            {/* Sabbath School */}
            <div className="b-card">
              <div className="b-card-header">
                <h3>Sabbath School</h3>
                <p>Saturdays · 9:30 AM – 11:00 AM</p>
              </div>
              <div className="b-card-body">
                {renderBulletinRows(sabbathSchoolEvents)}
              </div>
            </div>

            {/* Divine Service */}
            <div className="b-card">
              <div className="b-card-header">
                <h3>Divine Service</h3>
                <p>Saturdays · 11:30 AM – 1:00 PM</p>
              </div>
              <div className="b-card-body">
                {renderBulletinRows(divineServiceEvents)}
              </div>
            </div>

          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
}

export default withScroll(Bulletin);